import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const getProfile = 'profile/my-profile';
const updateProfile = 'profile/update';
export const apiGetProfile = async (val) => {
  const datas = await http.post(`${URL + getProfile}`, val);
  return datas.data.data;
};
export const apiUpdateProfile = async (val) => {
  const datas = await http.post(`${URL + updateProfile}`, val);
  return datas.data.data;
};
